/**
 * Analytics Configuration
 * Configure your Google Analytics and Meta Pixel tracking IDs here
 */

export const ANALYTICS_CONFIG = {
  /**
   * Google Analytics 4 Measurement ID
   * Format: G-XXXXXXXXXX
   * Leave empty to disable Google Analytics tracking
   */
  GOOGLE_ANALYTICS_ID: 'G-YZ3DXF22YC',

  /**
   * Meta Pixel ID (Facebook Pixel)
   * Format: numeric string (e.g., '1234567890')
   * Leave empty to disable Meta Pixel tracking
   */
  META_PIXEL_ID: '4205851212987686',

  /**
   * Enable/disable analytics in development mode
   * Set to true to test tracking in development
   */
  ENABLE_IN_DEVELOPMENT: true,
};
